module.exports = __webpack_public_path__ + "static/img/FWXTP-BFaa0jfU.da2072c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/FWXTP-BFaa0jfU.png
// module id = Hg6G
// module chunks = 16